module.exports = __webpack_public_path__ + "img/order.395303e2.png";